export default "__VITE_ASSET__5df9cb1c__"